import React from 'react'
import { Link } from 'react-router-dom'

const WhatsNewShowSidebar = ({ relatedItems }) => (
    <>
        <h2>What's New?</h2>

        <div id="blog-listing" className="related-articles">
            <h4>Related Articles</h4>

            {relatedItems.map(relatedItem => {
                const {
                    fields: { slug, title, summaryText }
                } = relatedItem

                return (
                    <div className="border-box" key={slug}>
                        <h2>{title}</h2>
                        <p>{summaryText}</p>
                        <Link to={`/whatsnew/${slug}`} className="more-link">
                            Learn More
                        </Link>
                    </div>
                )
            })}
        </div>
    </>
)

export default WhatsNewShowSidebar
